<template>
  <div class='highWayAdd'>
    <div class='add'>
      <div class='baseInfo' v-loading='formLoading'>
        <div class='baseInfoContent'>
          <!-- <el-form :model="modifyData" label-width="120px" label-position="right" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <div-border label="基础信息" prop="plan">
              <div class="yang">
                <el-form-item label="供应商选择：" prop="highwayName" style="margin-top: 15px">
                  <el-select v-model="modifyData.highwayName" filterable size="mini" placeholder="请选择供应商" value-key="id">
                    <el-option v-for="(item) in consignorOption" :key="item.id" :label="item.name" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="线路选择:" prop="line">
                  <el-select v-model="modifyData.line" size="mini" filterable placeholder="请选择线路" value-key="id" @change="lineChange">
                    <el-option v-for="(item) in lineOption" :key="item.id" :label="item.line_name" :value="item"></el-option>
                  </el-select>
                  <div v-if="modifyData.line.line_name">
                    <el-row style="color: rgb(153, 153, 153);font-size: 12px;line-height: 18px;margin-bottom: 3px">
                      <el-col :span="24" v-if="!modifyData.line.departure_port_id">起始地：{{modifyData.line.start_address_name}}</el-col>
                      <el-col :span="24" v-else>起始地：{{modifyData.line.start_address_name}}【{{modifyData.line.departure_port}}】</el-col>
                    </el-row>
                    <el-row style="color: rgb(153, 153, 153);font-size: 12px;line-height: 18px;">
                      <el-col :span="24" v-if="!modifyData.line.arrive_port_id">终止地：{{modifyData.line.end_address_name}}</el-col>
                      <el-col :span="24" v-else>{{modifyData.line.start_address_name}}【{{modifyData.line.arrive_port}}】</el-col>
                    </el-row>
                  </div>
                </el-form-item>
                <el-row>
                  <el-col :span="11">
                    <el-form-item label="有效期始：" prop="validityTime">
                      <el-date-picker
                        v-model="modifyData.validityTime"
                        style="width: 100%"
                        size="mini"
                        type="datetime"
                        placeholder="选择日期时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="validityTimeChange">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="结束时间:" prop="endTime" label-width="85px">
                      <el-date-picker
                        v-model="modifyData.endTime"
                        style="width: 100%"
                        size="mini"
                        type="datetime"
                        placeholder="选择日期时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="timeChange">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div-border>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <div style="padding: 15px 0" class="basicsStyle" >
                  <div-border label="价格设置" style="padding: 29px 20px">
                    <div>
                      <el-table
                        :data="modifyData.lineIncome"
                        v-loading="tableLoad"
                        style="width: 100%"
                        border
                        :header-cell-style="{color:'#3B3B3B','font-size':'13px',height:'35px',background:'#E8E8E8'}"
                        :cell-style="{'color':'#7F7F7F','font-size':'13px'}"
                        tooltip-effect="dark"
                        ref="carTableRef">
                        <el-table-column type="index" width="50" align="center" label="序号"></el-table-column>
                        <el-table-column label="适用车型" prop="model" width="150" align="center" >
                          <template slot-scope="scope">
                            <el-form-item label-width="0px" :prop="`lineIncome[${scope.$index}].model`" :rules="rules.model">
                              <el-cascader
                                v-model="scope.row.model"
                                size="mini"
                                style="width: 100%"
                                :options="modelOption"
                                :props="{value:'id',label:'model',children:'carModel',multiple: true}"
                                clearable filterable
                                placeholder="请选择适用车型"
                                @change="handleChange"/>
                            </el-form-item>
                          </template>
                        </el-table-column>
                        <el-table-column label="税率%" prop="taxRate" width="100" align="center" >
                          <template slot-scope="scope">
                            <el-form-item label-width="0px" :prop="`lineIncome[${scope.$index}].taxRate`" :rules="rules.taxRate">
                              <el-input size="mini"  v-model="scope.row.taxRate" placeholder="请输入税率"/>
                            </el-form-item>
                          </template>
                        </el-table-column>
                        <el-table-column label="合同价格" prop="contractPrice" width="100" align="center" >
                          <template slot-scope="scope">
                            <el-form-item label-width="0px" :prop="`lineIncome[${scope.$index}].contractPrice`" :rules="rules.contractPrice">
                              <el-input size="mini"  v-model="scope.row.contractPrice" placeholder="合同价格"/>
                            </el-form-item>
                          </template>
                        </el-table-column>
                        <el-table-column label="预结算价格" prop="preparePrice" width="120" align="center" >
                          <template slot-scope="scope">
                            <el-form-item label-width="0px" :prop="`lineIncome[${scope.$index}].preparePrice`" :rules="rules.preparePrice">
                              <el-input size="mini"  v-model="scope.row.preparePrice" placeholder="预结算价格">
                                <i slot="suffix" class="input-right">元</i>
                              </el-input>
                            </el-form-item>
                          </template>
                        </el-table-column>
                        <el-table-column label="预估价格" prop="estimatePrice" width="100" align="center" >
                          <template slot-scope="scope">
                            <el-form-item label-width="0px" :prop="`lineIncome[${scope.$index}].estimatePrice`" :rules="rules.estimatePrice">
                              <el-input size="mini"  v-model="scope.row.estimatePrice" placeholder="预估价格">
                              </el-input>
                            </el-form-item>
                          </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="50">
                          <i class="el-icon-error" style="font-size: 20px;cursor:pointer"
                             slot-scope="scope" @click="deleteTable(scope.$index)"
                          ></i>
                        </el-table-column>
                        <div slot="append" style="padding:9px">
                          <el-button type="warning" icon="el-icon-plus" circle style="padding: 4px;"
                                     @click="addMaterial">
                          </el-button>
                          <span style="margin:10px">添加</span>
                        </div>
                      </el-table>
                    </div>
                  </div-border>
                </div>
            </el-tabs>
          </el-form> -->

          <el-form
            :model='modifyData'
            label-width='120px'
            label-position='right'
            :rules='rules'
            ref='ruleForm'
            class='demo-ruleForm'>
            <div-border label='基础信息' prop='plan' v-if='editType === 0'>
              <el-row>
                <el-col :span='24'>
                  <el-form-item label='线路选择：' prop='line' style='margin-top: 15px'>
                    <el-select v-model='modifyData.line' filterable style='width:100%' size='small'
                               placeholder='请选择线路' value-key='id'>
                      <el-option v-for='(item) in lineOption' :key='item.id' :label='item.line_name'
                                 :value='item'></el-option>
                    </el-select>
                    <div v-if="modifyData.line.line_name && modifyData.line.line_name!=''">
                      <el-row
                        style='color: rgb(153, 153, 153);font-size: 12px;line-height: 18px;margin-bottom: 3px;'>
                        <el-col v-if='!modifyData.line.departure_port_id' :span='24'>
                          起始地：{{ modifyData.line.start_address_name }}
                        </el-col>
                        <el-col v-else :span='24'>
                          起始地：{{
                            modifyData.line.start_address_name
                          }}【{{ modifyData.line.departure_port }}】
                        </el-col>
                      </el-row>
                      <el-row style='color: rgb(153, 153, 153);font-size: 12px;line-height: 18px;'>
                        <el-col v-if='!modifyData.line.arrive_port_id' :span='24'>
                          终止地：{{ modifyData.line.end_address_name }}
                        </el-col>
                        <el-col v-else :span='24'>
                          终止地：{{ modifyData.line.end_address_name }}【{{
                            modifyData.line.arrive_port
                          }}】
                        </el-col>
                      </el-row>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span='24'>
                  <el-form-item label='供应商：' prop='entrust'>
                    <el-select v-model='modifyData.entrust' style='width:100%' filterable
                               size='small' value-key='id' placeholder='请选择供应商' @change="getContract">
                      <el-option v-for='item in consignorOption' :key='item.id' :label='item.name'
                                 :value='item'></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div-border>
            <div style='padding: 15px 0' class='basicsStyle'>
              <div-border label='价格设置' style='padding: 29px 20px'>
                <el-row>
                  <el-col :span='24'>
                    <el-form-item label='适配车型：' prop='model'>
                      <cascader ref='cascader' :options='modelOption' :props='props'
                                :filed='"model"'
                                @getValue='getValue' />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if='editType === 0'>
                  <el-col :span='24'>
                    <el-form-item label='税率：' prop='taxRate'>
                      <el-input size='small' v-model='modifyData.taxRate' placeholder='请输入税率' />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if='editType === 0'>
                  <el-col :span='24'>
                    <el-form-item label='结算价设置：'>
                      <el-row>
                        <el-col :span='12'>
                          <span
                            class='item-span'>{{
                              modifyData.priceType == 1 ? '合同价' : (modifyData.priceType == 2 ? '预结算价' : '未设置')
                            }}</span>
                        </el-col>
                        <el-col :span='12'>
                          <span
                            class='item-span'>{{
                              modifyData.priceType && modifyData.priceType != 0 ? '价格：' + modifyData.price : ''
                            }}</span>
                          <span class='set-up' @click='priceSetBtn'>设置</span>
                        </el-col>
                      </el-row>
<!--                      <el-row v-if='modifyData.companyName||modifyData.codeNumber'>-->
<!--                        <el-col :span='12'>-->
<!--                          <span class='item-span'>合同名称：{{ modifyData.companyName }}</span>-->
<!--                        </el-col>-->
<!--                        <el-col :span='12'>-->
<!--                          <span class='item-span'>合同编号：{{ modifyData.codeNumber }}</span>-->
<!--                        </el-col>-->
<!--                      </el-row>-->
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if='editType === 0'>
                  <el-col :span='24'>
                    <el-form-item label='预估价：' prop='estimatePrice'>
                      <el-input size='small' v-model='modifyData.estimatePrice'
                                placeholder='请输入预估价' />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if='editType === 0'>
                  <el-col :span='12'>
                    <el-form-item label='开始时间：' prop='startTime'>
                      <el-date-picker
                        v-model='modifyData.startTime'
                        style='width: 100%'
                        size='small'
                        type='datetime'
                        placeholder='选择开始时间'
                        value-format='yyyy-MM-dd HH:mm:ss'
                        @change='validityTimeChange'
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span='12'>
                    <el-form-item label='结束时间:' prop='endTime'>
                      <el-date-picker
                        v-model='modifyData.endTime'
                        style='width: 100%'
                        size='small'
                        type='datetime'
                        placeholder='选择结束时间'
                        value-format='yyyy-MM-dd HH:mm:ss'
                        @change='timeChange'
                        default-time="23:59:59"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div-border>
            </div>
            <div>
              <div-border label="合同设置" style='padding: 29px 20px'>
                <el-row>
                  <el-col :span='24'>
                    <el-form-item label='合同：' prop='contract'>
                      <el-select v-model="modifyData.contract" filterable style="width: 100%" size="small"
                                 placeholder="请选择合同" value-key="id">
                        <el-option
                          v-for="item in contractOption" :key="item.id" :label="item.name"
                          :value="item"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div-border>
            </div>
          </el-form>
        </div>
        <div class='btnContainer'>
          <el-button size='medium' class='searchBtn' :loading='loading' @click='addClick'>
            {{ this.dataD.showNumber === 1 ? '添加' : '修改' }}
          </el-button>
          <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
        </div>
      </div>
    </div>

    <!-- 结算价格设置 -->
    <el-dialog title='结算价格设置' :visible.sync='priceSetVisible' :close-on-click-modal='false'
               append-to-body width='910px'>
      <div-border label='价格设置'>
        <el-form :model='priceSetForm' label-width='100px'>
          <el-form-item label='结算方式：' style='margin-top: 15px'>
            <span style='display:inline-block;width:320px'>
              <el-radio-group v-model='priceSetForm.type' @change='typeChange'>
                <el-radio :label='0'>未设置</el-radio>
                <el-radio :label='1'>合同价格</el-radio>
                <el-radio :label='2'>预结算价格</el-radio>
              </el-radio-group>
            </span>
            <span
              style='display:inline-block;width:calc(100% - 320px);text-align:right;padding-right:15px;'>
              <el-input size='small' v-if='priceSetForm.type!==0' v-model='priceSetForm.price'
                        placeholder='请输入价格' style='width:calc(100% - 150px);margin-right:10px' />
              <el-button size='small' class='searchBtn' @click='priceSetConfirm'>确定</el-button>
              <el-button size='small' class='resetBtn'
                         @click='priceSetVisible = false'>取消</el-button>
            </span>
          </el-form-item>
        </el-form>
      </div-border>
<!--      <div-border :is-need='true' v-if='priceSetForm.type!=0' label='选择合同'-->
<!--                  style='padding: 29px 20px'>-->
<!--        <div class='nav'>-->
<!--          <div class='navContainer'>-->
<!--            <p>合同编号：</p>-->
<!--            <el-input v-model='condition.codeNumber' size='mini' style='width:150px'-->
<!--                      placeholder='请输入合同编号' />-->
<!--          </div>-->
<!--          <div class='navContainer'>-->
<!--            <p>合同名称：</p>-->
<!--            <el-input v-model='condition.contractName' size='mini' style='width:150px'-->
<!--                      placeholder='请输入合同名称' />-->
<!--          </div>-->
<!--          <div class='navContainer'>-->
<!--            <p>签约单位：</p>-->
<!--            <el-input v-model='condition.companyName' size='mini' style='width:150px'-->
<!--                      placeholder='请输入签约单位' />-->
<!--          </div>-->
<!--          <div class='navBtn'>-->
<!--            <el-button size='small' class='searchBtn' @click='_contractPageList'>查询</el-button>-->
<!--            <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>-->
<!--          </div>-->
<!--        </div>-->
<!--        <el-table :data='contractData' highlight-current-row border ref='contractTable'-->
<!--                  @current-change='contractChange' v-loading='contractLoad'-->
<!--                  :header-cell-style="{color:'#3B3B3B','font-weight':'700','padding':'0px','font-size':'13px',height:'35px',background:'#E8E8E8',}"-->
<!--                  :cell-style="{ color:'#7F7F7F','font-size':'13px' }">-->
<!--          <el-table-column type='index' width='50' />-->
<!--          <el-table-column property='codeNumber' label='合同编号' min-width='150' align='center' />-->
<!--          <el-table-column property='contractName' label='合同名称' min-width='150' align='center' />-->
<!--          <el-table-column property='typeName' label='合同类型' min-width='100' align='center' />-->
<!--          <el-table-column property='companyName' label='签约单位' min-width='150' align='center' />-->
<!--          <el-table-column property='startDate' label='开始日期' min-width='100' :formatter='getDate'-->
<!--                           align='center' />-->
<!--          <el-table-column property='endDate' label='结束日期' min-width='100' :formatter='getDate'-->
<!--                           align='center' />-->
<!--        </el-table>-->
<!--        <div style='margin-top: 20px'>-->
<!--          <el-pagination-->
<!--            background-->
<!--            :page-sizes='[10, 20, 30, 40]'-->
<!--            layout='total, sizes, prev, pager, next, jumper'-->
<!--            :total='total'-->
<!--            @size-change='contractSizeChange'-->
<!--            @current-change='contractCurrentChange'-->
<!--            :current-page.sync='page'-->
<!--            :page-size='rows'-->
<!--          />-->
<!--        </div>-->
<!--      </div-border>-->
    </el-dialog>
  </div>
</template>

<script>
  import { baseUrl } from '@/config/env';
  import uploadImg from '@/components/uploadImg';
  import divBorder from '@/components/divBorder';
  import cascader from '@/components/cascader';
  import { publicSelectLine } from '@/service/vehiclelog';
  import { formatDateTime } from '@/config/mUtils';
  import {
    getCarSerieList, contractPageList, highwayLineSelectList,
    highwayLineAdd, highwayLineUpdate,
  } from '@/service/financial';

  export default {
    components: {
      uploadImg,
      divBorder,
      cascader,
    },
    props: ['dataD', 'addType', 'editType'],
    // props:['showNumber','reviseData'],
    data() {
      var validatorLine = (rule, value, callback) => {
        if (value.line_name === '') {
          callback(new Error('请选择线路'));
        } else {
          callback();
        }
      };
      return {
        // modifyData:{
        //   line: {  //线路设置
        //     line_name:'',
        //     start_address_name:'',
        //     departure_port: '',
        //     departure_port_id: '',
        //     arrive_port: '',
        //     arrive_port_id: '',
        //     end_address_name:''
        //   },
        //   highwayName:'',//公路供应商
        //   validityTime: '',
        //   endTime:'',
        //   contractPrice:'',
        //   budget:'',//预结算价格
        //   budgetType:'',//预结算方式
        //   budgetInput:'',//预结算方式  默认单价
        //   estimate:'',//预估价格
        //   taxRate:'',
        //   lineIncome:[
        //     {
        //       // consignor:'',
        //       model:'',
        //       taxRate:'',
        //       contractPrice:'',
        //       preparePrice:'',
        //       estimatePrice:'',
        //       // prepareTypePrice:'',
        //       // prepareType:'1',
        //     }
        //   ],
        // },

        modifyData: {
          line: {  //线路设置
            id: '',
            line_name: '',
            start_address_name: '',
            departure_port: '',
            departure_port_id: '',
            arrive_port: '',
            arrive_port_id: '',
            end_address_name: '',
          },
          contract: '',
          entrust: {
            id: '',
            name: '',
          },  // 供应商
          startTime: '',  // 有效期始
          endTime: '',   // 结束时间
          model: '',  // 适配车型
          taxRate: '',    // 税率
          priceType: '',    // 结算类型
          price: '',    // 结算价格
          companyName: '',  // 合同名称
          codeNumber: '',    // 合同编号
          estimatePrice: '',   // 预估价
        },
        contractOption: [],
        // 合同编号弹窗 数据
        condition: {
          codeNumber: '',
          contractName: '',
          companyName: '',
        },
        contractLoad: false,
        contractData: [],
        selectContract: {
          id: '',
          codeNumber: '',
          companyName: '',
          startDate: '',
          endDate: '',
        },
        // 结算价格设置弹窗 数据
        priceSetForm: {
          type: 0,
          price: '',
        },
        priceSetVisible: this.addType,
        //总数据条数
        total: 0,
        //当前页数
        page: 1,
        //每页显示多少条数据
        rows: 10,
        lineOption: [],
        consignorOption: [],
        modelOption: [],
        modelMap: new Map(),
        brandMap: new Map(),
        activeName: 'default',
        lineIncome: [
          {
            consignor: '',
            model: '',
            taxRate: '',
            contractPrice: '',
            preparePrice: '税率',
            estimatePrice: '88',
          },
        ],
        loading: false,
        operationData: [
          {
            operateTime: '2021-8-31 15:49:58',
            operateType: '启用',
            account: '王三文',
            remark: '',
          },
          {
            operateTime: '2021-8-31 15:49:58',
            operateType: '禁用',
            account: '张三丰',
            remark: '',
          },
          {
            operateTime: '2021-8-31 15:49:58',
            operateType: '添加',
            account: '赵兮雪',
            remark: '',
          },
        ],
        tableLoad: false,
        rules: {
          taxRate: {
            required: true,
            message: '请输入税率',
            trigger: 'blur',
          },
          line: {
            required: true,
            message: '请选择线路',
            trigger: 'blur',
          },
          model: {
            required: true,
            message: '请选择车型',
            trigger: 'blur',
          },
          startTime: {
            required: true,
            message: '请选择开始时间',
            trigger: 'blur',
          },
          endTime: {
            required: true,
            message: '请选择结束时间',
            trigger: 'blur',
          },
          entrust: {
            required: true,
            message: '请选择供应商',
            trigger: 'blur',
          },
          contract: {
            required: true,
            message: '请选择合同',
            trigger: 'blur',
          },
        },
        formLoading: false,

        props: {
          value: 'id',
          label: 'model',
          children: 'carModel',
          multiple: true,
        },
      };
    },
    methods: {
      // 时间长度处理
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      // 修改默认数据
      async getRevise() {
        this.formLoading = true
        let modelList = [];
        if (this.dataD.data.carModelList && this.dataD.data.carModelList.length > 0) {
          this.dataD.data.carModelList.forEach(item => {
            modelList.push([item.brandId, item.modelId]);
          });
        }
        this.$refs.cascader.value = modelList;
        let name = '';
        if (this.dataD.data.contractCode != null && this.dataD.data.contractCode !== '') {
          name = this.dataD.data.contractCode + '-' + this.dataD.data.contractName;
        } else {
          name = null;
        }
        this.modifyData = {
          id: this.dataD.data.id,
          startTime: formatDateTime(this.dataD.data.startDate, 'yyyy-mm-dd hh:ii:ss'),
          endTime: formatDateTime(this.dataD.data.endDate, 'yyyy-mm-dd hh:ii:ss'),
          line: {
            line_name: '',
            start_address_name: '',
            end_address_name: '',
            departure_port: '',
            departure_port_id: '',
            arrive_port: '',
            arrive_port_id: '',
          },
          entrust: {
            id: this.dataD.data.highwayId,
            name: this.dataD.data.highwayName,
          },  // 供应商
          contract:  {
            id: this.dataD.data.contractId,
            name :name
          },//合同
          model: modelList,  // 适配车型
          taxRate: this.dataD.data.taxRate,    // 税率
          priceType: this.dataD.data.preparePrice ? '2' : (this.dataD.data.contractPrice ? '1' : ''),    // 结算类型
          price: this.dataD.data.contractPrice || this.dataD.data.preparePrice,    // 结算价格
          companyId: this.dataD.data.contractId,    // 合同id
          companyName: this.dataD.data.contractName,  // 合同名称
          codeNumber: this.dataD.data.contractCode,    // 合同编号
          estimatePrice: this.dataD.data.estimatePrice,   // 预估价
          contractPrice: this.dataD.data.contractPrice,   // 合同价
          preparePrice: this.dataD.data.preparePrice,   // 预结算价
        };
        let res = await publicSelectLine({ type: 1 });
        if (res.status !== 0) return this.$message.error(res.message);
        this.lineOption = res.data;
        if (this.lineOption.length > 0) {
          this.lineOption.forEach(item => {
            if (item.id == this.dataD.data.lineId) {
              this.modifyData.line = {
                id: item.id,
                line_name: item.line_name,
                start_address_name: item.start_address_name,
                end_address_name: item.end_address_name,
                departure_port: item.departure_port,
                departure_port_id: item.departure_port_id,
                arrive_port: item.arrive_port,
                arrive_port_id: item.arrive_port_id,
              };
            }
          });
        }
        let data = await contractPageList(this.modifyData.entrust.id);
        this.contractLoad = false;
        if (data.status !== 0) return this.$message.error(data.message);
        this.contractOption = data.data;
        // let res = await publicSelectLine({ type:1 })
        // if (res.status !==0) return  this.$message.error(res.message)
        // this.lineOption = res.data;
        // if(this.lineOption.length > 0) {
        //   this.lineOption.forEach(item => {
        //     if(this.reviseData.lineId == item.id) {
        //       this.modifyData.line ={
        //         id: item.id,
        //         line_name: item.line_name,
        //         start_address_name: item.start_address_name,
        //         end_address_name: item.end_address_name,
        //         departure_port: item.departure_port,
        //         departure_port_id: item.departure_port_id,
        //         arrive_port: item.arrive_port,
        //         arrive_port_id: item.arrive_port_id,
        //       }
        //     }
        //   })
        // }
        // if(this.reviseData.basics&&this.reviseData.basics.length > 0) {
        //   this.modifyData.lineIncome = [];
        //   this.reviseData.basics.forEach(item => {
        //     this.modifyData.lineIncome.push({
        //       ...item,
        //       model: item.carModelList&&item.carModelList.length>0?item.carModelList.map(r=>{return [r.brandId,r.modelId]}):[],
        //     })
        //   })
        // }
        this.$nextTick(() => {
          this.formLoading = false;
          console.log(this.modifyData);
        });
      },
      async _publicSelectLine(type) {
        let res = await publicSelectLine({
          type: type,
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.lineOption = res.data;
      },
      // 供应商
      async _customerInfoSelectList() {
        let res = await highwayLineSelectList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.consignorOption = res.data;
      },
      // 品牌/型号
      async _getCarSerieList() {
        let res = await getCarSerieList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.modelOption = res.data.filter(item => {
          return item.carModel.length != 0;
        });
        this.modelOption = this.modelOption.map(item => {
          item.carModel.forEach((item, index) => {
            this.modelMap.set(item.id, item.model);
            this.brandMap.set(item.brand_id, item.brand_name);
          });
          return {
            ...item,
            model: item.brand,

          };
        });
        // console.log(this.modelOption)
        this.modelOption.unshift({
          model: '全选',
          id: '全选',
        });
      },
      init() {
        this.uploadUrl = baseUrl + '/web/attachment/upload';
      },
      getContract(val){
        this.modifyData.contract = ''
        this._contractPageList(val)
      },
      // 选择合同 —— 分页查询
      async _contractPageList() {
        let obj = {
          // ...this.condition,
          id: this.modifyData.entrust.id,
          // page: this.page,
          // rows: this.rows,
        };
        this.contractLoad = true;
        let res = await contractPageList(obj);
        this.contractLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractOption = res.data;
        // this.total = res.data.total || 0;
        // if (this.modifyData.companyId && this.contractData.length > 0) {
        //   this.contractData.forEach(item => {
        //     if (item.id == this.modifyData.companyId) {
        //       this.$refs.contractTable.setCurrentRow(item);
        //     }
        //   });
        // }
      },
      // 重置
      resetBtn() {
        for (let key in this.condition) {
          this.condition[key] = '';
        }
      },
      contractSizeChange(rows) {
        this.rows = rows;
        this._contractPageList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._contractPageList();
      },
      // 合同编号 —— 选中数据
      contractChange(val) {
        this.selectContract = val;
      },
      // 结算方式改变
      typeChange(val) {
        if (this.dataD.showNumber == 1) return false;
        if (val == 1) {
          this.priceSetForm.price = this.modifyData.contractPrice;
        }
        if (val == 2) {
          this.priceSetForm.price = this.modifyData.preparePrice;
        }
      },
      // 结算价格设置
      priceSetBtn() {
        if (!this.modifyData.entrust.id || this.modifyData.entrust.id == '') {
          return this.$message.error('请选择供应商！');
        }
        this.priceSetForm = {
          type: this.modifyData.priceType ? parseInt(this.modifyData.priceType) : 0,
          price: this.modifyData.price ? this.modifyData.price : '',
        };
        this.selectContract = '';
        this._contractPageList();
        this.priceSetVisible = true;
      },
      // 结算价格设置 —— 确认
      priceSetConfirm() {
        if ((this.priceSetForm.type == 1 || this.priceSetForm.type == 2) && (!this.priceSetForm.price || this.priceSetForm.price == '')) {
          return this.$message.warning('请输入价格！');
        }
        // if (this.priceSetForm.type == 1 && (!this.selectContract.id || this.selectContract.id == '')) {
        //   return this.$message.warning('请选择合同！');
        // }
        this.modifyData.priceType = this.priceSetForm.type;

        if (this.priceSetForm.type == 0) {
          this.modifyData.price = '';
          this.modifyData.companyId = '';
          // this.modifyData.codeNumber = '';
          this.modifyData.companyName = '';
          if (this.dataD.showNumber == 1) {
            this.modifyData.startTime = '';
            this.modifyData.endTime = '';
          }
        } else {
          this.modifyData.price = this.priceSetForm.price;
          // this.modifyData.companyId = this.selectContract.id;
          // this.modifyData.codeNumber = this.selectContract.codeNumber;
          // this.modifyData.companyName = this.selectContract.contractName;
          // if (this.selectContract.startDate) this.modifyData.startTime = this.selectContract.startDate;
          // if (this.selectContract.endDate) this.modifyData.endTime = this.selectContract.endDate;
        }
        this.priceSetVisible = false;
      },
      handleClick() {
      },

      addClick() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            let {
              startTime,
              endTime,
              line,
              entrust,
              contract,
              priceType,
              companyId,
              taxRate,
              price,
              estimatePrice,
              model,
            } = this.modifyData;

            if ((!price || price == '') && (!estimatePrice || estimatePrice == '')) {
              return this.$message.warning('结算价格与预估价格至少有一个值！');
            }
            this.loading = true;
            if (this.dataD.showNumber === 1) {
              //基础价格设置
              // let type = false;
              // let flg = false;
              // let obj2 = {
              //   lineId:line.id,
              //   lineName:line.line_name,
              //   highwayId:highwayName.id,
              //   highwayName:highwayName.name,
              //   startDate:validityTime,
              //   endDate:endTime,
              //   taxRate:taxRate,
              //   contractPrice:contractPrice,
              //   preparePrice:budget,
              //   // prepareType:budgetType,
              //   // prepareTypePrice:budgetInput,
              //   estimatePrice:estimate,
              //   //为true时 lineInceme为空
              //   basics:this.modifyData.lineIncome===[] ? "":lineIncome.map(item=>{
              //     if(item.preparePrice == '' || !item.preparePrice){
              //       if(item.contractPrice == '' || !item.contractPrice) {
              //         return flg = true;
              //       }
              //       return{
              //         taxRate:item.taxRate,
              //         contractPrice:item.contractPrice,
              //         estimatePrice:item.estimatePrice,
              //         carModelList:item.model.map(item=>{
              //           return{
              //             modelId:item[1],
              //             modelName:this.modelMap.get(item[1]),
              //             brandId:item[0],
              //             brandName:this.brandMap.get(item[0]),
              //           }
              //         })
              //       }
              //     }else {
              //         return {
              //           taxRate: item.taxRate,
              //           contractPrice: item.contractPrice,
              //           preparePrice: item.preparePrice,
              //           estimatePrice: item.estimatePrice,
              //           carModelList: item.model.map((item) => {
              //             return {
              //               modelId: item[1],
              //               modelName: this.modelMap.get(item[1]),
              //               brandId:item[0],
              //               brandName:this.brandMap.get(item[0]),
              //             };
              //           }),
              //         }
              //     }
              //   })
              // }
              // if(flg) {
              //   this.loading = false;
              //   return this.$message.warning("合同单价和预结算单价至少有一种！");
              // }
              // if (obj2.consignorLineBasics ==="") delete obj2.consignorLineBasics

              let obj = {
                lineId: line.id,
                highwayId: entrust.id,
                highwayName: entrust.name,
                contractId: contract.id,
                startDate: startTime,
                endDate: endTime,
                basics: [{
                  taxRate: taxRate,
                  contractPrice: priceType == 1 ? price : '',  // 合同价格
                  preparePrice: priceType == 2 ? price : '',   // 预结算价格
                  estimatePrice: estimatePrice,
                  carModelList: model.map((item) => {
                    return {
                      modelId: item[1],
                      modelName: this.modelMap.get(item[1]),
                      brandId: item[0],
                      brandName: this.brandMap.get(item[0]),
                    };
                  }),
                }],
              };
              let res = await highwayLineAdd(obj);
              this.loading = false;
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
            } else {
              //修改
              this.loading = true
              let obj = {
                id: this.modifyData.id,
                lineId: line.id,
                highwayId: entrust.id,
                highwayName: entrust.name,
                contractId: contract.id,
                startDate: startTime,
                endDate: endTime,
                taxRate: taxRate,
                contractPrice: priceType == 1 ? price : '',  // 合同价格
                preparePrice: priceType == 2 ? price : '',   // 预结算价格
                estimatePrice: estimatePrice,
                carModelList: model.map((item) => {
                  return {
                    modelId:item[1],
                    modelName: this.modelMap.get(item[1]),
                    brandId: item[0],
                    brandName: this.brandMap.get(item[0]),
                  };
                }),
              };
              let res = await highwayLineUpdate(obj);
              this.loading = false;
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
            }
            this.$parent.$parent._lineConsignorLineList();
            this.dialogClose();
          } else {
            return false;
          }
        });
      },
      dialogClose() {
        this.modifyData = {
          line: {  //线路设置
            line_name: '',
            start_address_name: '',
            departure_port: '',
            departure_port_id: '',
            arrive_port: '',
            arrive_port_id: '',
            end_address_name: '',
          },
          entrust: '',  // 供应商
          contract: '',//合同
          startTime: '',  // 有效期始
          endTime: '',   // 结束时间
          model: '',  // 适配车型
          taxRate: '',    // 税率
          priceType: '',    // 结算类型
          price: '',    // 结算价格
          companyId: '',    // 合同id
          companyName: '',  // 合同名称
          codeNumber: '',    // 合同编号
          estimatePrice: '',   // 预估价
        };
        this.$refs.ruleForm.resetFields();
        this.$refs.cascader.value = [];
        this.$emit('addclose', false);
      },
      handleCurrentChange(val) {
        console.log(val);
      },
      //添加价格
      addMaterial() {
        this.modifyData.lineIncome.push(
          {
            model: '',
            taxRate: '',
            contractPrice: '',
            preparePrice: '',
            estimatePrice: '',
            // prepareTypePrice:'',
            // prepareType:'1',
          },
        );
      },
      deleteTable(index) {
        if (index > 0) {
          this.modifyData.lineIncome.splice(index, 1);
        }
      },
      getMax(date1, date2) {
        const oDate1 = new Date(date1);
        const oDate2 = new Date(date2);
        if (oDate1.getTime() > oDate2.getTime()) {
          console.log('第一个大');
          return true;
        } else {
          console.log('第二个大');
          return false;
        }
      },
      timeChange(value) {
        if (this.getMax(this.modifyData.validityTime, value)) {
          this.$message.warning('结束时间不能小于有效时间');
          this.modifyData.endTime = '';
        }

      },
      validityTimeChange(value) {
        // if (!this.getMax(value,new Date().getTime())){
        //   this.$message.warning('有效时间不能小于当前时间')
        //   this.modifyData.validityTime = ''
        // }
      },
      handleChange() {
      },
      lineChange() {
        this.$forceUpdate();
      },
      getValue(filed, data, isAll) {
        let subData = JSON.parse(JSON.stringify(data));
        isAll ? subData.shift() : '';
        this.modifyData[filed] = subData;
        console.log(this.modifyData);
      },
    },
  };
</script>

<style lang='scss' scoped>
  .highWayAdd {
    .el-dialog__wrapper {
      top: -52px;
    }

    ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after {
      color: #606266;
      content: "全选";
      font-size: 12px;
      margin-left: 2px;

    }

    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .el-form-item {
            margin-bottom: 15px;

            .el-input {
              width: 402px;
            }

            .el-form-item__error {
              top: 92%;
            }
          }

          .basicsStyle {
            .el-form-item {
              margin-top: 3px;
              margin-bottom: 5px;

              .el-input {
                width: 100%;
              }

              .el-select {
                width: 100%;
              }
            }

            .el-form-item__error {
              top: 96%;
            }

            .prepareType {
              .el-form-item__content {
                line-height: 24px;

              }
            }

            .el-icon-error {
              &:hover {
                color: #00cacc;
              }
            }
          }
        }

      }

      .el-table td, .el-table th {
        padding: 0;
      }

      .cell {
        font-size: 10px;
        padding: 0;
        font-weight: 900;
      }


      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }
  }

  ::v-deep {
    .transportTitle {
      z-index: 99;
    }

    .el-table__body tr.current-row > td {
      background-color: #409eff;
      color: #fff !important;
    }

    .cell .el-form-item {
      padding: 0 2px;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
      text-align: center;
    }

    .el-dialog__headerbtn {
      top: 0px;
      height: 42px;
      line-height: 42px;
      right: 10px;
      font-size: 20px;

      .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }
    }

    .el-dialog__title {
      color: #fff;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
    }

    .el-dialog__body {
      padding: 20px !important;
      max-height: 60vh;
      overflow-y: auto;
    }
  }

  .item-span {
    font-size: 13px;
  }

  .set-up {
    color: #3187ff;
    position: absolute;
    // width: 26px !important;
    padding-right: 10px;
    height: 24px;
    line-height: 24px;
    right: 10px;
    top: calc(50% - 12px);
    text-decoration: underline;
    cursor: pointer;
  }

  .navBtn {
    display: inline-block;
    width: calc(100% - 690px);
    text-align: right;
    margin-bottom: 10px;
  }

  .navContainer {
    display: inline-block;
    width: 230px;
    text-align: center;

    p {
      display: inline-block;
      width: 70px;
    }
  }
</style>
